<div class="toaster-container">
  <div
    class="toaster-notification"
    *ngFor="let notification of notifications"
    [ngClass]="notification.type"
  >
    <span class="message">{{ notification.message }}</span>
    <button class="close-btn" (click)="dismissNotification(notification.id)">×</button>
  </div>
</div>
